import { Action, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";

import { StateType } from "../../../../utils/types";
import {
  selectAssignment,
  selectAssignmentLoading,
  selectAssignmentSubmitLoading,
} from "../../../../redux/educator/selector";
import {
  getAssignmentById,
  userSubmitFiles,
} from "../../../../redux/educator/actions";
import { selectLessonPresignedUrl } from "../../../../redux/learner/selector";
import {
  getPresignedUrl,
  removePresignedUrl,
} from "../../../../redux/learner/actions";

const mapStateToProps = (state: StateType) => ({
  assignment: selectAssignment(state),
  presignedUrl: selectLessonPresignedUrl(state),
  loading: selectAssignmentLoading(state),
  submitLoading: selectAssignmentSubmitLoading(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators(
    {
      getAssignmentById,
      userSubmitFiles,
      getPresignedUrl,
      removePresignedUrl,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
